module.exports = __webpack_public_path__ + "static/assets/9011c61d954d3391a56d16d94561431d.svg";